import { AfterViewInit, Component, EventEmitter, Input, OnDestroy, Output, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';

import { BaseUI } from '../../base.ui';
import { Document, FullClient } from '../../../domain/data';
import { ParentEvents } from '../../../utils/parent-events.service';
import { ParentFormDirective } from '../../../directives/parent-form.directive';

@Component({
    selector: 'thr-full-data-six-legal-person',
    templateUrl: './full-data-six-legal-person.component.html',
    styleUrls: ['./full-data-six-legal-person.component.scss'],
})
export class FullDataSixLegalPersonComponent extends BaseUI implements AfterViewInit, OnDestroy {
    public form: NgForm;
    public isFormValid = false;

    @Input()
    client: FullClient;

    @Input()
    isDisabled = false;

    @Output()
    documentView: EventEmitter<Document> = new EventEmitter();

    @ViewChild('formDirective')
    formDirective: ParentFormDirective;

    constructor(parentEvents: ParentEvents) {
        super(parentEvents);
    }

    ngAfterViewInit() {
        super.ngAfterViewInit();
        this.form = this.formDirective.controlContainer as NgForm;

        if (this.form) {
            this.form.statusChanges.subscribe(() => {
                setTimeout(() => {
                    this.isFormValid = this.form.valid;
                });
            });
        }
    }

    onDocumentView(document: Document) {
        this.documentView.emit(document);
    }
}
